import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text } from 'pcln-design-system'

const handleClick = (cb) => (e) => {
  e?.stopPropagation()

  cb && cb()
}

export const MemberSignIn = ({ signInOnClick }) => (
  <Flex justifyContent='center' onClick={handleClick(signInOnClick)}>
    <Text color='primary.dark' bold fontSize={'11px'} mr={1}>
      Member Deal
    </Text>
    <Text color='primary.base' fontSize={'11px'}>
      Sign In
    </Text>
  </Flex>
)

MemberSignIn.propTypes = {
  /** Member sign in onclick callback */
  signInOnClick: PropTypes.func,
}
